// extracted by mini-css-extract-plugin
export var notificationHost = "_cw-0";